import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { setRulesErrors } from '../store/rules.actions'

export function* getRuleErrors(pcrDoc: IPcr) {
  const allErrors = pcrDoc.rules?.errors
  if (allErrors && Object.keys(allErrors).length) {
    yield put(setRulesErrors(allErrors))
  }
}
